import classNames from "classnames";
import React from "react";

import { useSelector } from "../../utils/hooks";
import icons from "../../utils/svgProvider";
import "./Alert.scss";

const Alert = () => {
	const message = useSelector((state) => state.popup.error.errorMessage);
	const level = useSelector((state) => state.popup.error.level);

	return (
		<div
			className={classNames({
				"addtocart-popup__alert-wrapper": true,
				[level]: true,
			})}
		>
			<i className="error--icon">{icons[level]}</i>
			<p
				className="error--message"
				dangerouslySetInnerHTML={{ __html: message }}
			/>
		</div>
	);
};

export default Alert;
